/* eslint-disable */
import React, { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import toast from 'react-hot-toast';
import MessageIcon from '@mui/icons-material/Message';

import { useQueryGetAllUsersList } from '../../hooks/react-query/useData';
import { getUserDetails } from '../../utils';
import PairedUsersMessaging from '../../components/pairedUsers/PairedUsersMessaging';

/**
 * Super Admin chat page: chat with any user on the platform.
 * Reuses PairedUsersMessaging with a user list from the admin users-list API.
 */
const AdminChat = () => {
  const navigate = useNavigate();
  const userDetails = getUserDetails();

  const { data: allUsersData, isFetching: isLoading } = useQueryGetAllUsersList(
    { token: userDetails?.token, role: userDetails?.role?.toLowerCase() },
    navigate,
    toast
  );

  const userList = useMemo(() => {
    if (!allUsersData?.data?.data) return [];
    const teachers = allUsersData.data?.data?.teachers || [];
    const edifiers = allUsersData.data?.data?.edifiers || [];
    
    return [...teachers, ...edifiers];
  }, [allUsersData]);

  return (
    <Container
      maxWidth="xl"
      sx={{
        p: '0 !important',
        flex: 1,
        minHeight: 0,
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Helmet>
        <title>Admin | Chat with Users</title>
      </Helmet>

      <PairedUsersMessaging
        pairedUsersList={userList}
        isLoading={isLoading}
        pageTitle="Chat with Users"
        emptyIcon={MessageIcon}
        emptyTitle="No Users Yet"
        emptyDescription="User list will appear here once users exist on the platform."
        showScheduleMeeting={false}
      />
    </Container>
  );
};

export default AdminChat;
